/* WUE Richardson 112 pitch sections
   Assets/wue-pitch.js
   Handles: estimated ship date, sticky bar, smooth scroll to the order section. */

(function () {
  "use strict";

  var ORDER_ID = "wue-order";

  function businessDaysFromToday(days) {
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }

  function fillShipDates() {
    var nodes = document.querySelectorAll("[data-wue-ship]");
    for (var i = 0; i < nodes.length; i++) {
      var days = parseInt(nodes[i].getAttribute("data-wue-ship"), 10);
      if (isNaN(days) || days < 1) days = 10;
      var date = businessDaysFromToday(days);
      var text;
      try {
        text = date.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
      } catch (e) {
        text = date.toDateString();
      }
      nodes[i].textContent = text;
    }
  }

  function smoothScroll() {
    document.addEventListener("click", function (e) {
      var link = e.target.closest ? e.target.closest('a[href^="#wue-"]') : null;
      if (!link) return;
      var id = link.getAttribute("href").slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      if (history.replaceState) history.replaceState(null, "", "#" + id);
    });
  }

  function stickyBar() {
    var bar = document.querySelector(".wue-pitch-sticky");
    if (!bar) return;
    var order = document.getElementById(ORDER_ID);
    var after = parseInt(bar.getAttribute("data-wue-after") || "600", 10);

    function update() {
      var past = window.pageYOffset > after;
      var nearOrder = false;
      if (order) {
        var r = order.getBoundingClientRect();
        nearOrder = r.top < window.innerHeight * 0.85;
      }
      if (past && !nearOrder) {
        bar.classList.add("is-visible");
      } else {
        bar.classList.remove("is-visible");
      }
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  var bound = false;
  function init() {
    fillShipDates();
    if (!bound) { smoothScroll(); bound = true; }
    stickyBar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Shopify theme editor: re-run when a section is added or reloaded
  document.addEventListener("shopify:section:load", init);
})();
